import React, { useEffect, useState } from "react";
import withConfig from "../config-validation/withConfig";
import ToolbarSocialButton from "./FluentSocialButton";
import ToolbarChatButton from "./FluentChatButton";
import { usePeopleList } from "../room/usePeopleList";
import { useSocialContext } from "../contexts/SocialContext";
import AiAgents from "../../singleton/AIAgents";
import voiceSynthesizer from "../../singleton/VoiceSynthetizer";
import { AGENT_EVENTS } from "../../utils/agent-utils";

export function SocialButtonContainer({ styles, scene, hubChannel, mySessionId, presences }) {
  const people = usePeopleList(presences, mySessionId);
  const agents = AiAgents.getAgents();

  // Only load voices when there are agents
  useEffect(() => {
    if (agents.length > 0) {
      voiceSynthesizer.loadVoices();
    }
  }, [agents]);

  // const {
  //   closeChat
  // } = useSocialContext();

  // const updateAgents = () => {
  //   setAgents()
  //   // const aiEntities = Array.from(getAiEntities());
  //   // const aiIds = aiEntities.map(entity => entity.components["npc-avatar"].npcId);

  //   // // Add new AI entities
  //   // aiEntities.forEach(entity => {
  //   //   if (entity.components["npc-avatar"] && !agents.some(agent => agent.id === entity.components["npc-avatar"].npcId)) {
  //   //     setAgents(prevAgents => [
  //   //       ...prevAgents,
  //   //       {
  //   //         id: entity.components["npc-avatar"].npcId,
  //   //         name: entity.components["npc-avatar"].name,
  //   //         isAi: true,
  //   //         thumbnail: AILogo
  //   //       }
  //   //     ]);
  //   //   }
  //   // });

  //   // // Remove AI entities that are no longer present
  //   // setAgents(prevAgents => prevAgents.filter(agent => aiIds.includes(agent.id)));
  // }

  // useEffect(() => {
  //   updateAgents();
  // }, []);

  // useEffect(() => {
  //   scene.addEventListener("environment-scene-loaded", event => {
  //     updateAgents();
  //     closeChat({clearUsers:true});

  //   });
  // }, [scene]);

  return (
    <SocialContent
      agents={agents}
      people={people}
      styles={styles}
      scene={scene}
      hubChannel={hubChannel}
      mySessionId={mySessionId}
      presences={presences}
    />
  );
}

// Separate component to use the context
function SocialContent({ agents, people, styles, scene, hubChannel, mySessionId }) {
  const {
    isOpenChat,
    isOpenParticipants,
    toggleParticipants,
    closeParticipants,
    isOpenSettings,
    setIsOpenSettings,
    openChatUser,
    toggleChat,
    selectedUserChat,
    closeChat,
  } = useSocialContext();

  const onAiProximity = async event => {
    const selectedAgent = agents.find(agent => agent?.id === event.detail);
    voiceSynthesizer.agent = selectedAgent;
    openChatUser(selectedAgent);

    await new Promise(resolve => setTimeout(resolve, 0));
    window.dispatchEvent(new CustomEvent("ai-proximity-voice"));
  };

  useEffect(() => {
    window.addEventListener(AGENT_EVENTS.AI_ON_ENTER_PROXIMITY, onAiProximity);
    return () => {
      window.removeEventListener(AGENT_EVENTS.AI_ON_ENTER_PROXIMITY, onAiProximity);
    };
  }, [agents]);

  return (
    <>
      <SocialButtonContainer.SocialButton
        agents={agents}
        people={people}
        openChatUser={openChatUser}
        styles={styles}
        scene={scene}
        hubChannel={hubChannel}
        mySessionId={mySessionId}
        isOpenChat={isOpenChat}
        isOpenParticipants={isOpenParticipants}
        toggleParticipants={toggleParticipants}
        closeParticipants={closeParticipants}
        isOpenSettings={isOpenSettings}
        setIsOpenSettings={setIsOpenSettings}
      />
      <SocialButtonContainer.ToolbarChatButton
        isOpenChat={isOpenChat}
        isOpenParticipants={isOpenParticipants}
        toggleChat={toggleChat}
        closeChat={closeChat}
        styles={styles}
        scene={scene}
        hubChannel={hubChannel}
        mySessionId={mySessionId}
        selectedUser={selectedUserChat}
      />
    </>
  );
}

SocialButtonContainer.SocialButton = withConfig(ToolbarSocialButton, `toolbar.socialButton.enabled`);
SocialButtonContainer.ToolbarChatButton = withConfig(ToolbarChatButton, `textChat.enabled`);
